import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  size = 20
}: {
  size?: number;
}) {
  return <div className="flex items-center gap-0.5" aria-label="4.9 de 5 estrellas" data-id="element-205" data-mp="3gpl0rvhz2acl">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="fill-amber-400 text-amber-400" style={{
      width: size,
      height: size
    }} data-id="element-206" data-mp="3kotu4z93o67m" data-mpi={i} />)}
    </div>;
}